import { useTranslation } from 'react-i18next';
import { authApi } from '@/lib/auth-api';

/**
 * Editorial Google + Apple buttons. Solid neutral fills (Google = white
 * with brand mark, Apple = slate-900). No drop shadows.
 */
export function OAuthButtons() {
  const { t } = useTranslation();
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
      <a
        href={authApi.oauthHref('google')}
        className="inline-flex h-11 items-center justify-center gap-2.5 rounded-md border border-border bg-card text-sm font-medium text-foreground hover:bg-ink-100 transition-colors"
      >
        <GoogleIcon />
        <span>{t('auth.continue_with_google')}</span>
      </a>
      <a
        href={authApi.oauthHref('apple')}
        className="inline-flex h-11 items-center justify-center gap-2.5 rounded-md bg-foreground text-background text-sm font-medium hover:bg-foreground/90 transition-colors"
      >
        <AppleIcon />
        <span>{t('auth.continue_with_apple')}</span>
      </a>
    </div>
  );
}

function GoogleIcon() {
  return (
    <svg className="h-4 w-4" viewBox="0 0 24 24" aria-hidden>
      <path d="M21.6 12.227c0-.708-.064-1.39-.182-2.045H12v3.868h5.382a4.6 4.6 0 01-1.995 3.018v2.51h3.23c1.89-1.74 2.983-4.305 2.983-7.351z" fill="#4285F4" />
      <path d="M12 22c2.7 0 4.964-.895 6.617-2.422l-3.23-2.51c-.895.6-2.04.954-3.387.954-2.605 0-4.81-1.76-5.598-4.123H3.064v2.59A9.996 9.996 0 0012 22z" fill="#34A853" />
      <path d="M6.402 13.9A6.01 6.01 0 016.082 12c0-.66.114-1.302.32-1.9V7.51H3.064A9.996 9.996 0 002 12c0 1.614.386 3.14 1.064 4.49l3.338-2.59z" fill="#FBBC05" />
      <path d="M12 5.977c1.468 0 2.787.504 3.823 1.495l2.868-2.868C16.96 2.999 14.696 2 12 2A9.996 9.996 0 003.064 7.51l3.338 2.59C7.19 7.737 9.395 5.977 12 5.977z" fill="#EA4335" />
    </svg>
  );
}

function AppleIcon() {
  return (
    <svg className="h-4 w-4" viewBox="0 0 24 24" fill="currentColor" aria-hidden>
      <path d="M16.365 1.43c0 1.14-.42 2.236-1.18 3.013-.76.776-2.005 1.366-3.005 1.286-.13-1.135.42-2.296 1.165-3.013.795-.755 2.085-1.31 3.02-1.286zM20.49 17.06c-.41.95-.61 1.376-1.14 2.215-.74 1.17-1.78 2.63-3.07 2.64-1.14.01-1.43-.74-2.98-.73-1.55.01-1.87.75-3.01.74-1.29-.01-2.27-1.32-3.01-2.49-2.07-3.26-2.29-7.09-1.01-9.13.91-1.45 2.34-2.3 3.69-2.3 1.37 0 2.23.75 3.36.75 1.1 0 1.77-.75 3.36-.75 1.2 0 2.47.65 3.38 1.78-2.97 1.63-2.49 5.87-.57 7.27z" />
    </svg>
  );
}
